import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-start gap-2 rounded-lg border-2 border-goldDeep bg-gold px-4 py-2 font-mono font-black text-forestDeep ${className}`} aria-label="Time remaining on this offer" data-id="element-261" data-mp="1ji3jpgma3sjo">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-262" data-mp="38u5oji7zauzh" data-mpi={index}>
          {index > 0 && <span className="pt-1 text-xl opacity-50" data-id="element-263" data-mp="38x1k4zwct7kr">:</span>}
          <span className="flex min-w-[38px] flex-col items-center leading-none" data-id="element-264" data-mp="34stu8ze5tlky">
            <b className="text-xl" data-id="element-265" data-mp="2c8gk6v2586b8">{String(value).padStart(2, '0')}</b>
            <small className="mt-1 font-sans text-[9px] font-bold uppercase tracking-wider text-goldDeep" data-id="element-266" data-mp="2h6i05749vpih">
              {label}
            </small>
          </span>
        </Fragment>)}
    </div>;
}